import React, { Fragment, useState, useEffect } from 'react';
import { Card, CardHeader, CardBody, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Row, Col } from 'reactstrap';
import SweetAlert from 'sweetalert2';
import DataTable from 'react-data-table-component';
import { H3, Btn, Breadcrumbs, H4 } from '../../../AbstractElements';
import { Link, useNavigate } from 'react-router-dom';
import { getClientUrlDataToken, postClientUrlWithToken } from '../../../Utils/restUtils';
import { Add, UserAgent, UserAgentList, Search, Filter, AdduserAgent, shiftAndSchedules, addShift } from '../../../Constant';
import { useForm } from 'react-hook-form';
import { Deleteagent, DeleteagentRole, getShiftDetails, getShiftDetailsRole, viewAccountRole, viewAgent, viewAgentRole } from '../../../CommonUrl';
import { useSelector } from 'react-redux';
import { conditionalRow } from '../../Common/Rowstyle/Rowstyle';
import Transparentspinner from '../../Common/Loader/Transparentspinner';
import { toast } from 'react-toastify';
// import PasswordChange from './PasswordChange';
import Popup from '../../Common/Popup/popup';
import { AgentColumns } from '../tableHeader';
import Button from '../../Common/Elements/Button';
import SchedulesCard from './SchedulesCard';
import AddShift from './AddShift';
// import AddEditStaff from './AddEditStaff';

const Shift = () => {
    const { register, handleSubmit } = useForm({});
    const navigate = useNavigate();
    const authState = useSelector((state) => state.auth);
    const toggleStyle = { padding: '10px 20px', opacity: '0.8', fontSize: '14px' }
    const changepwdtitile = <span className='billerqColor bolder '><h3>Change Password</h3></span>;
    const [agentLists, setAgentList] = useState([]);
    const [filters, setFilters] = useState({
        search: '',
    });
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [shiftDetails, setShiftDetails] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [userValue, setUserValue] = useState('');
    const [modal, setModal] = useState(false);
    const [sortConfig, setSortConfig] = useState({ column: '', order: '' });


    const handleSort = (column) => {
        let newOrder = 'asc';
        if (sortConfig.column === column.id) {
            newOrder = sortConfig.order === 'asc' ? 'desc' : 'asc';
        }
        setSortConfig({ column: column.id, order: newOrder });
        fetchAgent(currentPage, perPage, filters.search, column.id, newOrder);
    };

    const handleApiError = (status) => {
        if (status >= 400 && status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (status >= 500 && status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
    };

    const handleModal = (id) => {
        setUserValue(id);
        setModal(!modal);
    };
    const handlenaviaget = () => {
        navigate(`${process.env.PUBLIC_URL}/attendance/shifts/add`);
    }

    const ActionCell = ({ row }) => {
        const [dropdownOpen, setDropdownOpen] = React.useState(false);
        const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

        const handleEditClick = () => {
            const editFormURL = `${process.env.PUBLIC_URL}${process.env.PUBLIC_URL}/menu/employee-edit?id=${row.id}`;
            navigate(editFormURL);
        };

        const deleteCustomerList = (id) => {
            SweetAlert.fire({
                title: 'Confirm deletion?',
                text: 'This action cannot be undone.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ok',
                cancelButtonText: 'cancel',
                reverseButtons: true
            }).then(async (result) => {
                setLoading(true);
                if (result.value) {
                    const deleteRes = { agent_id: id }
                    const customerDelete = await postClientUrlWithToken(authState.apiUrl, authState.userRole === 1 ? Deleteagent : DeleteagentRole, deleteRes);
                    if (customerDelete.status === 200) {
                        if (customerDelete.data.status) {
                            SweetAlert.fire(
                                'Deleted!',
                                'Your file has been deleted.',
                                'success'
                            );
                            toast.success(customerDelete.data.message)
                            fetchAgent(1, perPage, sortConfig.column, sortConfig.order);
                        } else {
                            toast.error(customerDelete.data.message);
                        }

                    } else {
                        handleApiError(customerDelete.status);
                    }
                    setLoading(false);
                }
            });
        };

        return (
            <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                <DropdownToggle color="#00000" style={{ padding: '6px 12px', fontSize: '14px', zIndex: 1000 }}>
                    <i className="fa fa-ellipsis-v"></i>
                </DropdownToggle>
                <DropdownMenu container="body">
                    {
                        (authState.userRole === 1 ||
                            authState.permissions.includes('edit-user')) &&
                        <DropdownItem style={toggleStyle} onClick={() => handleEditClick()}>Edit</DropdownItem>
                    }
                    {
                        (authState.userRole === 1 ||
                            authState.permissions.includes('edit-user')) &&
                        <DropdownItem style={toggleStyle} onClick={() => handleModal(row.id)}>Change Password</DropdownItem>
                    }
                    {
                        (authState.userRole === 1 ||
                            authState.permissions.includes('delete-user')) &&
                        <DropdownItem style={{ padding: '10px 20px', color: 'red', opacity: '0.8', fontSize: '14px' }} onClick={() => deleteCustomerList(row.id)}>Delete</DropdownItem>
                    }
                </DropdownMenu>
            </Dropdown>
        );
    };

    const fetchAgent = async (page, size = perPage, searchKey = '', sortBy = '', sortOrder = '') => {
        setLoading(true);
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? viewAgent + `?page=${page}&page_length=${size}&search=${searchKey}&sort_by=${sortBy}&sort_order=${sortOrder}` : viewAgentRole +
            `?page=${page}&page_length=${size}&search=${searchKey}&sort_by=${sortBy}&sort_order=${sortOrder}`);
        const shiftResponse = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getShiftDetails + `?page=${page}&page_length=${size}&search=${searchKey}&sort_by=${sortBy}&sort_order=${sortOrder}` : getShiftDetailsRole +
            `?page=${page}&page_length=${size}&search=${searchKey}&sort_by=${sortBy}&sort_order=${sortOrder}`);

        setShiftDetails(shiftResponse.data.data)

        if (response.status === true) {
            setResetPaginationToggle(!resetPaginationToggle);
            const SerialNo = (page - 1) * size + 1;
            setAgentList(response.data.data.map((e, index) => {
                return {
                    Si: SerialNo + index,
                    Name: <span>{e.first_name} {e.last_name}</span>,
                    Email: e.email || 'N/A',
                    Roles: e.role_name,
                    Status: e.status,
                    id: e.id,
                    Mobile: e.mobile,
                    enableStock: e.stock_enabled
                }
            }))
            setTotalRows(response.data.total);
        } else {
            handleApiError(response.status);
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchAgent(1);
    }, []);

    const handlePageChange = page => {
        fetchAgent(page, perPage, filters.search, sortConfig.column, sortConfig.order);
        setCurrentPage(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        fetchAgent(page, newPerPage, filters.search, sortConfig.column, sortConfig.order);
        setPerPage(newPerPage);
    };

    const onSubmit = async (data) => {
        const search = data.search;
        setFilters({
            search,
        });
        fetchAgent(1, perPage, search);
    };

    return (
        <Fragment>
            {loading && <Transparentspinner />}
            <Breadcrumbs mainTitle={shiftAndSchedules} parent="Attendance" title={shiftAndSchedules} />
            <Card className='cardWidth'>
                <CardHeader >
                    <div className='d-flex align-items-center justify-content-between gap-2'>

                        <H3>{shiftAndSchedules}</H3>
                        {
                            //       (authState.userRole === 1 ||
                            // authState.permissions.includes('store-user')) && 
                            <div>
                                <Button onClick={handlenaviaget} className="btn btn-primary">{Add}</Button>
                            </div>
                        }
                    </div>
                    <SchedulesCard shifts={shiftDetails} onRefresh={() => fetchAgent(currentPage)} />
                </CardHeader>
            </Card>
            <Card className='cardWidth'>

                <div>
                </div>
                {/* <CardBody>
                    <span className='custom-span'>

                    </span>
                    <div className="order-history table-responsive">
                        <DataTable
                            columns={AgentColumns}
                            data={agentLists}
                            onSort={handleSort} // Attach sorting handler here
                            sortServer // Enable server-side sorting
                            pagination
                            paginationServer
                            defaultSortAsc
                            paginationTotalRows={totalRows}
                            paginationDefaultPage={currentPage}
                            onChangeRowsPerPage={handlePerRowsChange}
                            conditionalRowStyles={conditionalRow}
                            onChangePage={handlePageChange}
                            fixedHeader
                        />
                    </div>
                </CardBody> */}
            </Card>
            <Popup size="md" isOpen={modal} title={addShift} toggler={handleModal}>
                {/* <AddEditStaff /> */}
                <AddShift />
                {/* <PasswordChange setModal={setModal}  userValue={userValue}/> */}
            </Popup>
        </Fragment>
    );
};

export default Shift;